/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TotalsDto } from '../../models/totals-dto';

export interface FactorTotalsTodayGet$Plain$Params {
}

export function factorTotalsTodayGet$Plain(http: HttpClient, rootUrl: string, params?: FactorTotalsTodayGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TotalsDto>> {
  const rb = new RequestBuilder(rootUrl, factorTotalsTodayGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TotalsDto>;
    })
  );
}

factorTotalsTodayGet$Plain.PATH = '/Factor/totals-today';
